const accessoryImages = [
    "/images/accessories/prod_chairs_lg.jpg",
    "/images/accessories/prod_cases_lg.jpg",
    "/images/accessories/prod_crates_lg.jpg",
    "/images/accessories/prod_crates2_lg.jpg",
    "/images/accessories/prod_litracks_lg.jpg",
    "/images/accessories/prod_tablethrow6_lg.jpg",
    "/images/accessories/prod_tablethrow5_lg.jpg",
    "/images/accessories/prod_tablethrow4_lg.jpg",
    "/images/accessories/prod_tablethrows_lg.jpg",
    "/images/accessories/prod_tablethrow2_lg.jpg",
    "/images/accessories/prod_tablethrow3_lg.jpg",
    "/images/accessories/prod_outdoor_event_lg.jpg",
    "/images/accessories/prod_outdoor_flag_lg.jpg",
    "/images/accessories/avantor-counter.jpg",
    "/images/accessories/sai-counter.jpg",
    "/images/accessories/prod_counters_lg.jpg",
    "/images/accessories/prod_counters2_lg.jpg",
    "/images/custom/nusil-monitor.jpg",
    "/images/accessories/prod_tv_stand_lg.jpg",
];

const accessoryCaptions = [
    "Chairs",
    "Shipping Cases for Displays and Graphics",
    "Custom Shipping Crates",
    "Inside of a Custom Shipping Crate",
    "Literature Racks",
    "Custom Tablethrow",
    "Custom Tablethrow",
    "Custom Tablethrow",
    "Custom Tablethrow",
    "Custom Tablethrow",
    "Custom Tablethrow",
    "Outdoor and Event Products",
    "Outdoor Flags",
    "Counter with rear storage",
    "Counter with front storage",
    "Counters",
    "Custom Counters",
    "Custom TV Stand",
    "Custom TV Stand",
];

const data = {
    chairs: {
        sampleImage: "/images/accessories/prod_chairs.jpg",
        sampleAlt: "chairs",
        pdf: "",
        index: 0,
        showButton: false,
        images: accessoryImages,
        captions: accessoryCaptions
    },
    cases: {
        sampleImage: "/images/accessories/prod_cases.jpg",
        sampleAlt: "shipping cases",
        pdf: "",
        index: 1,
        showButton: false,
        images: accessoryImages,
        captions: accessoryCaptions
    },
    crates: {
        sampleImage: "/images/accessories/prod_crates.jpg",
        sampleAlt: "custom shipping crates",
        pdf: "",
        index: 2,
        showButton: false,
        images: accessoryImages,
        captions: accessoryCaptions
    },
    litracks: {
        sampleImage: "/images/accessories/prod_litracks.jpg",
        sampleAlt: "literature racks",
        pdf: "",
        index: 4,
        showButton: false,
        images: accessoryImages,
        captions: accessoryCaptions
    },
    tablethrows: {
        sampleImage: "/images/accessories/prod_tablethrows.jpg",
        sampleAlt: "Tablethrows",
        pdf: "",
        index: 5,
        showButton: false,
        images: accessoryImages,
        captions: accessoryCaptions
    },
    outdoor_event: {
        sampleImage: "/images/accessories/prod_outdoor_event.jpg",
        sampleAlt: "Outdoor and Event Products",
        pdf: "",
        index: 11,
        showButton: false,
        images: accessoryImages,
        captions: accessoryCaptions
    },
    counters: {
        sampleImage: "/images/accessories/prod_counters.jpg",
        sampleAlt: "Counters and TV Stands",
        pdf: "",
        index: 13,
        showButton: false,
        images: accessoryImages,
        captions: accessoryCaptions
    }
};

export default data;




// WEBPACK FOOTER //
// ./src/data/accessories.js